import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  snackbarMsg: { tipo: "success", mensaje: "" },
  backdrop: { open: false, message: "" }
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    showErrorMessage: (state, action) => {
      state.snackbarMsg = { tipo: "error", mensaje: action.payload };
    },
    showSuccessMessage: (state, action) => {
      state.snackbarMsg = { tipo: "success", mensaje: action.payload };
    },
    showInfoMessage: (state, action) => {
      state.snackbarMsg = { tipo: "info", mensaje: action.payload };
    },
    setBackdropAction: (state, action) => {
      const { open, id } = action.payload;
      // eslint-disable-next-line eqeqeq
      if (open || (!open && id == state.backdrop.id)) {
        state.backdrop = { open, id };
      }
    }
  }
});

export const {
  showErrorMessage,
  showSuccessMessage,
  showInfoMessage,
  setBackdropAction
} = appSlice.actions;

// Kept as a plain action-creator wrapper (not a thunk) matching the old call
// signature `setBackdrop(open, id)` used across ~16 view files.
export const setBackdrop = (backdrop, id) =>
  setBackdropAction({ open: backdrop, id });

export default appSlice.reducer;
